import React from 'react';
import Navbar from '../../../components/navbar/ui/Navbar';
import Footer from '../../../components/footer/ui/Footer';
import WhatsAppButton from '../../../components/whatsapp-button/ui/WhatsAppButton';
import ScrollToTop from '../../../components/scroll-to-top/ui/ScrollToTop';
import SEO from '../../../components/seo/SEO';
import HelpCard from '../../../components/help-card/ui/HelpCard';
import WorkshopSection from '../components/ui/WorkshopSection';
import { seoData } from '../../../../data/seoData';

const WorkshopPage: React.FC = () => {
    return (
        <>
            <SEO 
                title={seoData.workshop.title}
                description={seoData.workshop.description}
                keywords={seoData.workshop.keywords}
                canonical={seoData.workshop.canonical}
            />
        <div className="workshop-page">
            <Navbar />
            <WorkshopSection />
            <section className="container">
                <HelpCard />
            </section>
            <Footer />
            <WhatsAppButton />
            <ScrollToTop />
        </div>
        </>
    );
};

export default WorkshopPage;

